import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, FormControl, Select,InputLabel, Input, MenuItem} from '@material-ui/core'



 

export default class ImportaFisierDialog extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
     
         }
    }

     componentDidMount(){
  
    }

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="pm-alert-dialog"
                disableEscapeKeyDown
                fullWidth={true}
                maxWidth={'md'} 
                 open={this.props.open}
                 onClose={this.props.dialogClose}
            
                 >
                 <DialogActions >
                 <Fab  onClick={this.props.dialogClose} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text-dialog'>close</i>
                            </Fab>
                 </DialogActions>
               <DialogContent>
                   <Grid container style={{position:'relative'}}>
                   <Grid style={{ width: 'fit-content', marginTop: 10, display: this.props.isBilantButton === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={3} lg={3} xl={3} >
                     
                   <div onClick={this.props.bilantClick} style={{
                        backgroundColor: '#12E822',
                        minHeight: 100,
                        marginTop: 10,
                        width: 150,
                       
                        right: 20,
                        zIndex: 6000,
                    }} className='pm-top-menu-cards' >

                        <span style={{
                            bottom: 10,
                            fontSize: 26,
                            margin: 'unset',
                            left: 5,
                            bottom: 10
                        }} className='pm-home-card-text'>
                            {this.props.dictionary.financiarContabil.importaBilant}
                            </span>
                        <i style={{ fontSize: 52 }} className='material-icons pm-top-menu-buttons-icons'>description</i>

                    </div>
                    </Grid>

                     <Grid style={{ width: 'fit-content', marginTop: 10, display: this.props.isBilantButton === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={3} lg={3} xl={3} >
                    
                    <div onClick={this.props.balantaClick} style={{
                        backgroundColor: '#7C36EB',
                        minHeight: 100,
                        marginTop: 10,
                        width: 150,
                       
                        right: 20,
                        zIndex: 6000,
                    }} className='pm-top-menu-cards' >

                        <span style={{
                            bottom: 10,
                            fontSize: 26,
                            margin: 'unset',
                            left: 5,
                            bottom: 10
                        }} className='pm-home-card-text'>
                            {this.props.dictionary.financiarContabil.importaBalanta}
                            </span>
                        <i style={{ fontSize: 52 }} className='material-icons pm-top-menu-buttons-icons'>description</i>

                    </div>
                    </Grid>

                     <Grid style={{ width: 'fit-content', marginTop: 10, display: this.props.isBilantButton === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={3} lg={3} xl={3} >
                    
                    <div onClick={this.props.clientiClick}  style={{
                        backgroundColor: '#EA6B33',
                        minHeight: 100,
                        marginTop: 10,
                        width: 150,
                     
                        right: 20,
                        zIndex: 6000,
                    }} className='pm-top-menu-cards' >

                        <span style={{
                            bottom: 10,
                            fontSize: 26,
                            margin: 'unset',
                            left: 5,
                            bottom: 10
                        }} className='pm-home-card-text'>
                            {this.props.dictionary.financiarContabil.importaClienti}
                            </span>
                        <i style={{ fontSize: 52 }} className='material-icons pm-top-menu-buttons-icons'>description</i>

                    </div>

                     
                        {/* <Button onClick={this.props.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBilant}</Button>
                        <Button onClick={this.props.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBalanta}</Button>
                        <Button onClick={this.props.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaClienti}</Button>
                    */}
                        </Grid> 

                        <Grid style={{ width: 'fit-content', marginTop: 10, display: this.props.isBilantButton === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={3} lg={3} xl={3} >
                    
                    <div onClick={this.props.creeazaBilantManual}  style={{
                        backgroundColor: 'rgb(51, 165, 234)',
                        minHeight: 100,
                        marginTop: 10,
                        width: 150,
                     
                        right: 20,
                        zIndex: 6000,
                    }} className='pm-top-menu-cards' >

                        <span style={{
                            bottom: 10,
                            fontSize: 26,
                            margin: 'unset',
                            left: 5,
                            bottom: 10
                        }} className='pm-home-card-text'>
                            Creeaza Bilant Manual
                            </span>
                        <i style={{ fontSize: 52 }} className='material-icons pm-top-menu-buttons-icons'>description</i>

                    </div>

                     
                        {/* <Button onClick={this.props.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBilant}</Button>
                        <Button onClick={this.props.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBalanta}</Button>
                        <Button onClick={this.props.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaClienti}</Button>
                    */}
                        </Grid> 
                        <Grid style={{ width: 'fit-content', marginTop: 10, display: this.props.isBilantButton === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={3} lg={3} xl={3} >
                    
                    <div onClick={this.props.creeazaBalantaManual}  style={{
                        backgroundColor: 'rgb(234, 51, 176)',
                        minHeight: 100,
                        marginTop: 10,
                        width: 150,
                     
                        right: 20,
                        zIndex: 6000,
                    }} className='pm-top-menu-cards' >

                        <span style={{
                            bottom: 10,
                            fontSize: 26,
                            margin: 'unset',
                            left: 5,
                            bottom: 10
                        }} className='pm-home-card-text'>
                            Creeaza Balanta Manual
                            </span>
                        <i style={{ fontSize: 52 }} className='material-icons pm-top-menu-buttons-icons'>description</i>

                    </div>

                     
                        {/* <Button onClick={this.props.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBilant}</Button>
                        <Button onClick={this.props.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBalanta}</Button>
                        <Button onClick={this.props.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaClienti}</Button>
                    */}
                        </Grid> 

                        <Grid style={{ width: 'fit-content', marginTop: 10, display: this.props.isBilantButton === true ? 'block' : 'none'  }} className="loginButton" item xs={12} sm={12} md={3} lg={3} xl={3} >
                    
                    <div onClick={()=>{this.props.history.push('/planificare')}}  style={{
                        backgroundColor: 'rgb(226, 199, 93)',
                        minHeight: 100,
                        marginTop: 10,
                        width: 150,
                     
                        right: 20,
                        zIndex: 6000,
                    }} className='pm-top-menu-cards' >

                        <span style={{
                            bottom: 10,
                            fontSize: 26,
                            margin: 'unset',
                            left: 5,
                            bottom: 10
                        }} className='pm-home-card-text'>
                            Planificare
                            </span>
                        <i style={{ fontSize: 52 }} className='material-icons pm-top-menu-buttons-icons'>description</i>

                    </div>

                     
                        {/* <Button onClick={this.props.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBilant}</Button>
                        <Button onClick={this.props.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBalanta}</Button>
                        <Button onClick={this.props.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaClienti}</Button>
                    */}
                        </Grid> 
                        <Grid style={{ width: 'fit-content', marginTop: 10, display: this.props.isBilantButton === true ? 'block' : 'none'  }} className="loginButton" item xs={12} sm={12} md={3} lg={3} xl={3} >
                    
                    <div onClick={this.props.furnizorClick}  style={{
                        backgroundColor: 'rgb(21, 214, 207)',
                        minHeight: 100,
                        marginTop: 10,
                        width: 150,
                     
                        right: 20,
                        zIndex: 6000,
                    }} className='pm-top-menu-cards' >

                        <span style={{
                            bottom: 10,
                            fontSize: 26,
                            margin: 'unset',
                            left: 5,
                            bottom: 10
                        }} className='pm-home-card-text'>
                            Importa Furnizor
                            </span>
                        <i style={{ fontSize: 52 }} className='material-icons pm-top-menu-buttons-icons'>description</i>

                    </div>

                     
                        {/* <Button onClick={this.props.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBilant}</Button>
                        <Button onClick={this.props.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBalanta}</Button>
                        <Button onClick={this.props.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaClienti}</Button>
                    */}
                        </Grid> 

                        <Grid style={{ width: 'fit-content', marginTop: 10, display: this.props.isBilantButton === true ? 'block' : 'none'  }} className="loginButton" item xs={12} sm={12} md={3} lg={3} xl={3} >
                    
                    <div onClick={this.props.biletOridin}  style={{
                        backgroundColor: 'rgb(234, 35, 60)',
                        minHeight: 100,
                        marginTop: 10,
                        width: 150,
                     
                        right: 20,
                        zIndex: 6000,
                    }} className='pm-top-menu-cards' >

                        <span style={{
                            bottom: 10,
                            fontSize: 26,
                            margin: 'unset',
                            left: 5,
                            bottom: 10
                        }} className='pm-home-card-text'>
                            Cecuri si bilet de ordin
                            </span>
                        <i style={{ fontSize: 52 }} className='material-icons pm-top-menu-buttons-icons'>description</i>

                    </div>

                     
                        {/* <Button onClick={this.props.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBilant}</Button>
                        <Button onClick={this.props.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaBalanta}</Button>
                        <Button onClick={this.props.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.importaClienti}</Button>
                    */}
                        </Grid> 
                        
                    <Grid style={{ display: this.props.isSelectYear === true ? 'block' : 'none', textAlign:'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <FormControl className='inputFocus' style={{ width: '30%', margin:'auto', marginTop: 20 }}>
                            <InputLabel htmlFor="resursa">{this.props.dictionary.financiarContabil.selecteazaAnul}</InputLabel>
                            <Select

                                value={this.props.nrYear || ""}
                                onChange={(ev) => { this.props.onYearSelect(ev) }}

                                input={<Input id="resursa" />}>


                                {this.props.listYears.map((s, idx) => {
                                    return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>


                    </Grid>

                    <Grid style={{ display: this.props.isSelectLuna === true ? 'block' : 'none', textAlign:'center'  }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <FormControl className='inputFocus' style={{ width: '30%',margin:'auto' , marginTop: 20 }}>
                            <InputLabel htmlFor="resursa">{this.props.dictionary.financiarContabil.selecteazaLuna}</InputLabel>
                            <Select

                                value={this.props.luna || ""}
                                onChange={(ev) => { this.props.onMonthSelect(ev) }}

                                input={<Input id="resursa" />}>


                                {this.props.listMonths.map((s, idx) => {
                                    return <MenuItem value={s.id} key={idx}  > {s.luna}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid style={{ width: 'fit-content', display: this.props.isSelectFisierBilant === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} >
                        {/* <Button onClick={() => { this.props.selectFile('import-bilant') }} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.selecteazaFisier}</Button> */}
                        <input id="import-bilant" type="file" accept="file/*"
                            onChange={() => { this.props.importBilant('import-bilant') }}
                            style={{ display: 'none' }}
                        ></input>
                    </Grid>
                    <Grid style={{ width: 'fit-content', display: this.props.isSelectFisierFurnizori === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} >
                        {/* <Button onClick={() => { this.props.selectFile('import-furnizori') }} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.selecteazaFisier}</Button> */}
                        <input id="import-furnizori" type="file" accept="file/*"
                            onChange={() => { this.props.importFurnizor('import-furnizori') }}
                            style={{ display: 'none' }}
                        ></input>
                    </Grid>

                    <Grid style={{ width: 'fit-content', display: this.props.isSelectFisierBalanta === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} >
                        {/* <Button onClick={() => { this.props.selectFile('import-balanta') }} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.selecteazaFisier}</Button> */}
                        <input id="import-balanta" type="file" accept="file/*"
                            onChange={() => { this.props.importBalanta('import-balanta') }}
                            style={{ display: 'none' }}
                        ></input>
                    </Grid>

                    <Grid style={{ width: 'fit-content', display: this.props.isSelectFisierClienti === true ? 'block' : 'none' }} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} >
                        {/* <Button onClick={() => { this.props.selectFile('import-clienti') }} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.props.dictionary.financiarContabil.selecteazaFisier}</Button> */}
                        <input id="import-clienti" type="file" accept="file/*"
                            onChange={() => { this.props.importClienti('import-clienti') }}
                            style={{ display: 'none' }}
                        ></input>
                    </Grid>
                    <div style={{
                        position: 'fixed',
                        zIndex: 6000,
                        bottom: 50,
                        display: this.props.isPopUp === true ? 'block' : 'none',
                        right: 50,
                        color: this.props.isPopSucces ? '#18d618' : 'red',
                        backgroundColor:'white',
                        padding:10, 
                        borderRadius:20,
                        textAlign:'center'

                    }}>



                        <i style={{
                            fontSize: 60
                        }} className='material-icons'> {this.props.isPopSucces ? 'thumb_up' : 'thumb_down'}</i>
                        <br />

                        <span >{this.props.textPopup}</span>

                    </div>

                   </Grid>

               </DialogContent>
                       
                   
                 </Dialog>
         </div>
        );
       }
}